import type { Type_ICalendarEvent } from '../../../zap/Type/Type.hive'

export const activity_SET_REPORT_EVENT = 'activity_SET_REPORT_EVENT' as const
export const activity_CANCEL_REPORT = 'activity_CANCEL_REPORT' as const

export type TActivityAction =
    | { type: 'activity_SET_REPORT_EVENT'; event: Type_ICalendarEvent }
    | { type: 'activity_CANCEL_REPORT' }

export const setReportEvent = (event: Type_ICalendarEvent): TActivityAction => ({
    type: activity_SET_REPORT_EVENT,
    event,
})

export const cancelReport = (): TActivityAction => ({ type: activity_CANCEL_REPORT })
